import React, { useState, useEffect } from "react";
import "./dev-rate-update.scss";
import { connect } from "react-redux";
import { 
  Ineligible, 
  RateNotAccepted, 
  RateStillHigher, 
  ScheduleConfirmed, 
  SuccessfullyUpdated, 
  Trial, 
  UpdateIneligible 
} from "./Trial";
import { Switch, Route } from "react-router-dom";
import RateUpdateForm from "./RateUpdateForm";
import {
  CommonInfoProvider,
  Footer,
  DefaultLoadingScreen,
  useCommonInfo,
  redirectIfNotCurrent,
  excludeRedirectCheckUrls,
  DevUpdateUrls,
  LoaderModal,
  TuringHeader,
  FailureModal
} from "./common";

const Container = ({ children }) => {
  const [showRedirectionLoader, setShowRedirectionLoader] = useState(false);
  const { 
    loading, 
    profileLoading, 
    eligible, 
    rateUpdated, 
    remainingAttempts, 
    formSubmitting, 
    inRange, 
    rateSubmitted,
    failure
  } = useCommonInfo();

  const showLoadingModal = (loading || profileLoading);

  const  redirectLoader = () => { 
    setShowRedirectionLoader(true);
  }

  useEffect(() => {
    /*
    User Flow Description
    The code follows the following flow from a user perspective:

    - Wait until loading modal is not visible (i.e. eligibility api call is finished):
    - Check if the user's rate has been already updated:
      - If the rate has been updated:
          - Check if the rate is within the recommended range:
            - If yes, redirect the user to the success page.
            - If not, redirect the user to the still high rate page.
      - If the rate has not been updated and the user has no remaining attempts:
          - Redirect the user to attempt page, to accept last submitted rate
      - If the user is not eligible:
          - Redirect the user to the ineligible page.
      - If the user has remaining attempts greater than 2:
          - Redirect the user to the rate review page.
    */
    if (!showLoadingModal) {
      if (!excludeRedirectCheckUrls.includes(window.location.pathname)) {
        if(rateUpdated) {
          redirectIfNotCurrent(DevUpdateUrls.SUCCESS, redirectLoader);
        } else if (rateSubmitted) {
          redirectIfNotCurrent(DevUpdateUrls.HIGH_RATE, redirectLoader);
        }else if (!rateUpdated && remainingAttempts == 0) {
          redirectIfNotCurrent(DevUpdateUrls.ATTEMPT, redirectLoader);
        } else if (
          !eligible
        ) {
          redirectIfNotCurrent(DevUpdateUrls.INELIGIBLE, redirectLoader);
        } else if (remainingAttempts > 2) {
          redirectIfNotCurrent(DevUpdateUrls.REVIEW, redirectLoader);
        }
      }
    }
  }, [showLoadingModal, remainingAttempts, rateUpdated])

  const showScreen = !showLoadingModal && !formSubmitting && !showRedirectionLoader;
  
  return (
    <>
      {showLoadingModal && (
        <div className="container"> <DefaultLoadingScreen /></div>
      )}
      {showRedirectionLoader && (
        <div className="container"> <DefaultLoadingScreen text="Redirecting..." /></div>
      )}
      {failure && <FailureModal />}
      {formSubmitting && (
        <div className="container">
          <LoaderModal text="Processing your information......" visible={true} />
          {children}
        </div>
      )}
      {showScreen && <div className="container">{children}</div>}
    </>
  );
};

const DevRateUpdate = ({ dispatch }) => {
  return (
    <div className="dev-rate-update">
      <CommonInfoProvider>
        <TuringHeader />
        <Container>
          <Switch>
            <Route exact path={DevUpdateUrls.REVIEW}>
              <RateUpdateForm />
            </Route>
            <Route exact path={DevUpdateUrls.ATTEMPT}>
              <Trial />
            </Route>
            <Route exact path={DevUpdateUrls.NOT_ACCEPTED}>
              <RateNotAccepted />
            </Route>
            <Route exact path={DevUpdateUrls.INELIGIBLE}>
              <Ineligible />
            </Route>
            <Route exact path={DevUpdateUrls.HIGH_RATE}>
              <RateStillHigher />
            </Route>
            <Route exact path={DevUpdateUrls.SUCCESS}>
              <SuccessfullyUpdated />
            </Route>
            <Route exact path={DevUpdateUrls.CONFIRM_CALL_SCHEDULE}>
              <ScheduleConfirmed />
            </Route>
            <Route exact path={DevUpdateUrls.UPDATE_INELIGIBLE}>
              <UpdateIneligible />
            </Route>
          </Switch>
        </Container>
        <Footer />
      </CommonInfoProvider>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    basicProfile: state.basicProfile,
    profile: state.profile,
  };
};

export default connect(mapStateToProps, null)(DevRateUpdate);
